export const ROUTING_SOURCE = {
  GOOGLE: 'google',
  METROPIA: 'metropia',
}
